module.exports = __webpack_public_path__ + "static/img/ana_1.828e011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo_sur/ana_1.png
// module id = pGJT
// module chunks = 0